import { useSetBranchCloseWarning } from "@/shared/atoms/useBranchCloseAtom";
import { get2 } from "@/shared/axios";
import useIsAuth from "@/shared/hooks/useIsAuth";
import useUserSettingsHook from "@/shared/hooks/useUserSettingsHook";
import { allDeliveryMethods, allSources } from "@/shared/utils/constant";
import { randomLiveInterval } from "@/shared/utils/helpers";
import { Branch } from "@/shared/utils/interfaces";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import useOrdersQueryKey, { orderStatuses } from "../hooks/useOrdersQueryKey";
import { OrdersLive } from "./interfacesV2";

// query responsible for fetching orders with given params for v2

export const ordersQueryFn = async (
  branch: number,
  params?: any
): Promise<OrdersLive> => {
  return await get2(
    `internal/secure/pos/v2/orders/information/all/live/${branch}`,
    {
      params
    }
  );
};

const useOrdersQuery = (
  order_statuses = orderStatuses,
  hasOffset = 1,
  localBranch?: Branch
) => {
  const isAuth = useIsAuth();
  const setBranchCloseWarning = useSetBranchCloseWarning();
  const { query: userSettingsQuery } = useUserSettingsHook();
  const { branch, queryKey } = useOrdersQueryKey(order_statuses, localBranch);
  const query = useQuery<OrdersLive>({
    queryKey,
    queryFn: () =>
      ordersQueryFn(branch, {
        hasOffset,
        order_statuses,
        sources: allSources,
        delivery_methods: allDeliveryMethods
      }),

    initialData: [],
    placeholderData: keepPreviousData,
    enabled:
      isAuth &&
      order_statuses.length !== 0 &&
      branch !== undefined &&
      userSettingsQuery.isSuccess,
    refetchInterval: randomLiveInterval(),
    refetchIntervalInBackground: true,
    retry: 3
  });

  useEffect(() => {
    if (query.isSuccess) {
      setBranchCloseWarning(false);
    }
    if (query.isError) {
      setBranchCloseWarning(true);
    }
  }, [query.isSuccess, query.isError]);

  const today = query?.data?.[0] ?? [];

  return { ...query, today };
};

export default useOrdersQuery;
